<i18n>
{
	"en": {
		"save": "Save parameters",
		"parameterName":  "Parameter name",
		"parameterDescription": "Parameter Description",
		"parameterValue": "Value",
		"parametersChanged": "Parameters changed: "
	},
	"no": {
		"save": "Lagre parameterer",
		"parameterName":  "Parameter navn",
		"parameterDescription": "Parameter beskrivelse",
		"parameterValue": "Verdi",
		"parametersChanged": "Antall parameterer som ble oppdatert: "
	}
}
</i18n>
<template>
	<div class="system-settings">

		<t-grid
			ref="settingsGrid"
			:key="'settingsGridKey'"
			style="height:450px;"
			:columnDefinitions="columnDefinitions"
			:defaultColumnDefinition="defaultColumnDefinition"
			:rowHeight="70"
			:items="getAllAvailableSettings"
			@rowDoubleClick="showLog"
		>
			<template v-slot:value="{ displayValue, item }">
				<t-text-input v-model="item.value"/>
			</template>

		</t-grid>
		<t-button width="160px" iconBefore="database" @click="processSave">{{$t('save')}}</t-button>
		<SystemSettingsChangeLog
			:isShown="logShown"
			:systemSetting="selectedSetting"
			@close="logShown = false"
			@cancel="logShown = false"
			@ok="logShown = false"
		/>
	</div>

</template>

<script>
import deepCopy from 'deepcopy';
import { mapGetters, mapActions } from './store/settings.store';
import SystemSettingsChangeLog from './systemSettings/systemSettingsChangeLog.vue';

export default {
	name: 'SystemSettings',
	components: { SystemSettingsChangeLog },
	data() {
		return {
			selectedSetting: null,
			originalParameterValues: [],
			logShown: false,
			columnDefinitions: [
				{
					field: 'id',
					displayName: this.$t('parameterName'),
					resizable: true,
					width: 150
				},
				{
					field: 'value',
					displayName: this.$t('parameterValue'),
					resizable: true,
					width: 350
				},
				{
					field: 'description',
					displayName: this.$t('parameterDescription'),
					resizable: true,
					width: 150
				},
			],
			defaultColumnDefinition: { resizable: true }
		};
	},

	computed: { ...mapGetters(['getAllAvailableSettings']) },

	watch: {
		getAllAvailableSettings: {
			deep: true,
			handler(parameters) {
				parameters.forEach((parameter) => {
					let originalParameter = this.originalParameterValues.find(x => x.id === parameter.id);
					if (!originalParameter)
						return;
					let changed = originalParameter.value !== parameter.value;
					this.markParameterAsChanged({ parameter: parameter, changed: changed });
				});
			},
		}
	},
	async created() {
		await this.getSettings();
		this.originalParameterValues = deepCopy(this.getAllAvailableSettings);
	},

	methods: {
		...mapActions([ 'getSettings', 'saveSystemSettings', 'markParameterAsChanged' ]),
		showLog(value) {
			this.selectedSetting = this.getAllAvailableSettings.find(x => x.id === value);
			this.logShown = true;
		},
		close() {
			this.logShown = false;
		},
		async processSave() {
			let parametersChangedObject = await this.saveSystemSettings();

			this.$notify({
				type: 'success',
				title: `${this.$t('parametersChanged')} ${parametersChangedObject.changed}`
			});

			parametersChangedObject.parameters.forEach(parameter => {
				let originalParameter = this.originalParameterValues.find(x => x.id === parameter.id);
				originalParameter.value = parameter.value;
			});
			return false;
		},
	},


};
</script>

<style scoped>
</style>